import React from 'react';
import Moment from 'react-moment';
import 'moment-timezone';
import { Link } from 'react-router-dom';

class TableDisplay extends React.Component {
    static defaultProps = {
        titles: ["Champs 1"],
        indices: [],
        data: {},
        table: true,
        tableStriped: false,
        tableHover: false,
        thead: "primary",
        actions: [],
        withLink: false,
        withPaging: false,
        nb: 0,
        size: 100,
        current: 1,
        pagingTheme: "primary",
        onClick: (data) => {},
        onChangePage: (page) => {}
    }
    render() {
        // Table classes
        let tableClass = "";
        if (this.props.table) tableClass += "table ";
        if (this.props.tableStriped) tableClass += "table-striped ";
        if (this.props.tableHover) tableClass += "table-hover ";
        // Pagination
        let NB = 1;
        let TAB_PAGES = [];
        if (this.props.withPaging) {
            NB = (this.props.nb===0)?1:Math.ceil(this.props.nb/this.props.size);
            for(let i=0; i<NB; i++) TAB_PAGES.push(i+1);
        }
        // Computation
        let TOTAL = {};
        if (this.props.data.length==0) this.props.indices.forEach((e,i) => {TOTAL[`e${i}`]=0});
        // Output
        return (
            <div className="table-pane">
                <table className={tableClass} style={{fontSize: "12px"}}>
                    <thead className={"thead-"+this.props.thead}>
                        <tr>
                            {this.props.titles.map((title, index) => <th key={"table-titre-"+index}>{title}</th>)}
                            {(this.props.actions.length!==0) && <th>Actions</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                        this.props.data.map((d, index) => (
                        <tr key={"table-ligne-"+index} onClick={() => {this.props.onClick(d)}}>
                            {this.props.indices.map((indice, i) => {
                                let value, champ, tChamp;
                                if (Array.isArray(indice)) {
                                    value = "";
                                    for (const element of indice) {
                                        tChamp  = element.split(".");
                                        if (value!="") value += " ";
                                        if (tChamp.length==1) value += d[tChamp[0]];
                                        if (tChamp.length==2) {
                                            if (d[tChamp[0]]) {
                                                value += d[tChamp[0]][tChamp[1]];
                                            }
                                        }
                                        if (tChamp.length==3) {
                                            if (d[tChamp[0]][tChamp[1]]) {
                                                value += d[tChamp[0]][tChamp[1]][tChamp[2]];
                                            }
                                        }
                                    }
                                } else {
                                    tChamp = indice.split(".");
                                    value = d[tChamp[0]];
                                    if (tChamp.length==2) {
                                        if (value != null) {
                                            value = value[tChamp[1]];
                                        }
                                    }
                                    if (tChamp.length==3) {
                                        if (value[tChamp[1]]) {
                                            value = value[tChamp[1]][tChamp[2]];
                                        }
                                    }
                                }
                                champ = tChamp[0];
                                let type = typeof value;
                                let align = "left";
                                if (!TOTAL[champ]) {
                                    TOTAL[champ] = 0; //(type==="number" || type==="bigint")?:"";
                                }
                                if (type==="number" || type==="bigint" || (type==="string" && !isNaN(value))) {
                                    TOTAL[champ] += +value;
                                    value = new Intl.NumberFormat().format(value);
                                    align="right";
                                } else if (type==="boolean") {
                                    value = <i>{(value)?"Oui":"Non"}</i>;
                                } else if (value!==null) {
                                    if (value.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/)!==null) {
                                        value = <Moment format="DD/MM/YYYY à HH:mm">{value}</Moment>;
                                    }
                                }
                                return <td key={"table-row-"+index+"-"+i} align={align}>{(i===0 && this.props.withLink)?<Link to={this.props.withLink+d[champ]}>{value}</Link>:value}</td>
                            })}
                            {(this.props.actions.length!==0)?<td>{this.props.actions.map((action, bindex) => <button key={"option-button-"+index+"-"+bindex} type="button" className={action.className} onClick={()=>{action.onClick(d)}}>{action.caption}</button>)}</td>:''}
                        </tr>
                        ))}
                    </tbody>
                    {(this.props.withFooter) &&
                    <tfoot className={"thead-"+this.props.thead}>
                        <tr>
                            {Object.keys(TOTAL).map((indice, i) => <th key={"footer-row-"+i}>{(i===0 || TOTAL[indice]===0)?"":new Intl.NumberFormat().format(TOTAL[indice])}</th>)}
                            {(this.props.actions.length!==0) && <th></th>}
                        </tr>
                    </tfoot>
                    }
                </table>
                {(NB>1) &&
                <div className="text-center">
                    {TAB_PAGES.map((i) => <div key={"link-page-"+i} className={"btn btn-"+((i===this.props.current)?"outline-":"")+this.props.pagingTheme+" mr-1"} onClick={() => {if (i!==this.props.current) {this.props.onChangePage(i)}}}>{i}</div>
                    )}
                </div>
                }
            </div>
        );
    }
}

export default TableDisplay;